"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReturnsPublicApiMarketplace = void 0;
var ReturnsPublicApiMarketplace;
(function (ReturnsPublicApiMarketplace) {
    ReturnsPublicApiMarketplace["AIRSHOP"] = "AIRSHOP";
    ReturnsPublicApiMarketplace["AMAZON"] = "AMAZON";
    ReturnsPublicApiMarketplace["ARTEZA"] = "ARTEZA";
    ReturnsPublicApiMarketplace["BIGCOMMERCE"] = "BIGCOMMERCE";
    ReturnsPublicApiMarketplace["DELIVERR"] = "DELIVERR";
    ReturnsPublicApiMarketplace["EBAY"] = "EBAY";
    ReturnsPublicApiMarketplace["ETSY"] = "ETSY";
    ReturnsPublicApiMarketplace["FACEBOOK"] = "FACEBOOK";
    ReturnsPublicApiMarketplace["GOOGLE"] = "GOOGLE";
    ReturnsPublicApiMarketplace["INSTAGRAM"] = "INSTAGRAM";
    ReturnsPublicApiMarketplace["JANE"] = "JANE";
    ReturnsPublicApiMarketplace["JCPENNEY"] = "JCPENNEY";
    ReturnsPublicApiMarketplace["KROGER"] = "KROGER";
    ReturnsPublicApiMarketplace["MAGENTO"] = "MAGENTO";
    ReturnsPublicApiMarketplace["NEWEGG"] = "NEWEGG";
    ReturnsPublicApiMarketplace["OVERSTOCK"] = "OVERSTOCK";
    ReturnsPublicApiMarketplace["SHOPIFY"] = "SHOPIFY";
    ReturnsPublicApiMarketplace["SKUPREME"] = "SKUPREME";
    ReturnsPublicApiMarketplace["TARGET"] = "TARGET";
    ReturnsPublicApiMarketplace["WALMART"] = "WALMART";
    ReturnsPublicApiMarketplace["WISH"] = "WISH";
    ReturnsPublicApiMarketplace["WOOCOMMERCE"] = "WOOCOMMERCE";
    ReturnsPublicApiMarketplace["OTHER"] = "OTHER";
})(ReturnsPublicApiMarketplace || (exports.ReturnsPublicApiMarketplace = ReturnsPublicApiMarketplace = {}));
//# sourceMappingURL=ReturnsPublicApiMarketplace.js.map